/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type SensorsReportingStability =
  (typeof SensorsReportingStability)[keyof typeof SensorsReportingStability];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SensorsReportingStability = {
  ReportingStabilityStable: 'stable',
  ReportingStabilityVariable: 'variable',
  ReportingStabilityIrregular: 'irregular',
  ReportingStabilityInsufficientData: 'insufficient_data',
} as const;
